import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import SignatureCanvasLibrary from 'react-signature-canvas';
import { Box } from '@mui/material';

const SignatureCanvas = forwardRef(
  ({ onSignatureEnd, width = 500, height = 200 }, ref) => {
    const sigPadRef = useRef(null);

    useImperativeHandle(ref, () => ({
      clear: () => {
        if (sigPadRef.current) {
          sigPadRef.current.clear();
          if (onSignatureEnd) {
            onSignatureEnd(null);
          }
        }
      },
      isEmpty: () => {
        return sigPadRef.current ? sigPadRef.current.isEmpty() : true;
      },
      getDataURL: () => {
        return sigPadRef.current
          ? sigPadRef.current.toDataURL('image/jpeg', 0.8)
          : null;
      },
    }));

    const handleEnd = () => {
      if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
        const dataURL = sigPadRef.current.toDataURL('image/jpeg', 0.8);
        if (onSignatureEnd) {
          onSignatureEnd(dataURL);
        }
      } else if (onSignatureEnd) {
        onSignatureEnd(null);
      }
    };

    return (
      <Box
        sx={{
          border: '1px solid #ccc',
          borderRadius: 1,
          backgroundColor: '#ffffff',
          position: 'relative',
          width: '100%',
          height: height,
        }}
      >
        <SignatureCanvasLibrary
          ref={sigPadRef}
          canvasProps={{
            width: width,
            height: height,
            className: 'signature-canvas',
            style: {
              width: '100%',
              height: '100%',
              display: 'block',
            },
          }}
          onEnd={handleEnd}
          backgroundColor="#ffffff"
          penColor="#000000"
        />
      </Box>
    );
  }
);

SignatureCanvas.displayName = 'SignatureCanvas';

export default SignatureCanvas;
